import { render, staticRenderFns } from "./TxList.vue?vue&type=template&id=7cedfb5a&scoped=true&"
import script from "./TxList.vue?vue&type=script&lang=ts&"
export * from "./TxList.vue?vue&type=script&lang=ts&"
import style0 from "./TxList.vue?vue&type=style&index=0&id=7cedfb5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cedfb5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
